<template>
  <div class="auth-page">
    <b-container class="px-0">
      <b-row>
        <Alert v-if="(isBlocked || isExpired) && isMounted" customClass="mt-2" :title="isBlockedMsg" type="danger" />
        <Alert v-if="wasBlocked && isMounted" customClass="mt-2" title="Votre compte est débloqué. Un nouveau code vous a été envoyé afin de vous connecter" type="info" />
        <b-col v-if="!isExpired && isMounted" class="col-xs-12 col-lg-10 main">
          <h1>Pour vous connecter</h1>
          <div>
            <h4 v-if="email">Entrez le code à 6 chiffres que vous avez reçu par email à l'adresse mail {{ email }}</h4>
            <h4 v-else-if="phone">Entrez le code à 6 chiffres que vous avez reçu par message au {{ formatPhone }}</h4>
            <Otp
              ref="otp"
              inputRef="otpInput"
              @onComplete="completeOtp"
              :isError="errorOtp"
              :errorMsg="errorOtpMsg"
              :showCountdown="isCountdown && !isBlocked"
              :showSendAgain="!isCountdown && !isBlocked"
              :isDisabled="isLoading"
              @onSendAgain="resendOtp"
              @onCountDownEnd="countdownEnded"
              linkText="Renvoyer un nouveau code"
            />
            <button @click="validateOtpCollab" :disabled="isLoading || isBlocked || otp.length < 6" class="btn btn-info mt-1 mr-1 mb-1 mb-md-0" type="button">
              Continuer
            </button>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import logger from "@/utils/func/logger";
import Otp from '@/components/Otp/Otp';
import Alert from '@/components/Alert/Alert';

export default {
  name: 'MagicLinkPage',
  components: {
    Otp,
    Alert,
  },
  data() {
    return {
      time: 0,
      interval: null,
      isLoading: false,
      isCountdown: false,
      isBlocked: false,
      isExpired: false,
      wasBlocked: false,
      isMounted: false,
      isBlockedMsg: "",
      phone: null,
      email: null,
      otp: '',
      errorOtp: false,
      errorOtpMsg: '',
    };
  },
  created() {
    if (localStorage.getItem('token') && localStorage.getItem('user.role') && localStorage.getItem('user.id')) {
      this.$router.push('/app/installation');
    }
    this.isLoading = true;
    this.$store.dispatch('auth/magiclink', { url: this.$route.params.url })
      .then((res) => {
        this.isLoading = false;
        this.isMounted = true;
        logger.log('Success auth/magiclink', res);
        if (res.success) {
          this.phone = res.phone;
          if (res.email) {
            this.email = res.email;
          }
          this.isCountdown = true;
        } else {
          if (res.code === 403) {
            this.isBlocked = true;
            this.isBlockedMsg = res.message;
            this.isExpired = true;
          } else {
						this.phone = res.phone;
						if (res.email) {
							this.email = res.email;
						}
            this.isBlocked = true;
            this.time = res.timer;
            this.interval = setInterval(() => {
              this.time -= 1;
            }, 1000);
            this.isBlockedMsg = `Votre compte est temporairement bloqué. Veuillez attendre la page dans ${ this.$options.computed.formatTime(this.time) } et un nouveau code vous sera renvoyé pour vous connecter.`;
          }
        }
      })
      .catch((err) => {
        this.isLoading = false;
        logger.error('Err auth/magiclink', err);
      });
  },
  computed: {
    formatPhone() {
      const s = this.phone;
      if (!s) {
        return null;
      }
      return `${s.slice(0, 3)} ${s.slice(3, 4)} ${s.slice(4, 6)} ${s.slice(6, 8)} ${s.slice(8, 10)} ${s.slice(10, 12)}`
    },
    formatTime (value) {
      const minutes = Math.floor(parseInt(value, 10) / 60);
      const seconds = parseInt(value, 10) - minutes * 60;
      let res = '';
      if (minutes !== 0) {
        res += `${minutes.toString()} minute`;
        if (minutes !== 1) {
          res += 's';
        }
        res += ' ';
      }
      res += `${seconds.toString()} seconde`;
      if (seconds >= 1) {
        res += 's';
      }
      return res;
    }
  },
  watch: {
    time(n) {
      this.isBlockedMsg = `Votre compte est temporairement bloqué. Veuillez attendre la page dans ${ this.$options.computed.formatTime(n) } et un nouveau code vous sera renvoyé pour vous connecter.`;
      if (n === -1) {
        this.isBlocked = false;
        this.isBlockedMsg = '';
        this.wasBlocked = true;
        clearInterval(this.interval);
        this.interval = null;
        this.resendOtp();
      }
    },
  },
  methods: {
    resendOtp() {
      this.isLoading = true;
      this.$store.dispatch('auth/resendOtpCollab', { phone: this.phone })
        .then((res) => {
          logger.log('Success auth/resendOtpCollab', res);
          this.isLoading = false;
          this.isCountdown = true;
          this.errorOtp = false;
          this.errorOtpMsg = '';
        })
        .catch((err) => {
          logger.error('Err auth/resendOtpCollab', err);
          this.isLoading = false;
        });
    },
    completeOtp(nextOtp) {
      if (!this.isBlocked) {
        if (this.otp.length < 6) {
          this.otp = nextOtp;
          this.validateOtpCollab();
        } else {
          let prevOtp = this.otp;
          this.otp = nextOtp;
          if (prevOtp.slice(-1) !== nextOtp.slice(-1)) {
            this.validateOtpCollab();
          }
        }
      }
    },
    validateOtpCollab() {
      this.wasBlocked = false;
      this.isLoading = true;
      if (this.otp.trim().length === 6) {
        this.$store.dispatch('auth/validateOtpCollab', { phone: this.phone, otp: this.otp })
          .then((res) => {
            logger.log('Success auth/validateOtpCollab', res);
            this.isLoading = false;
            if (res.success) {
              this.errorOtp = false;
              this.errorOtpMsg = '';
              this.authenticate(res.euid)
            } else {
              if (res.isBlocked) {
                this.isBlocked = true;
                this.time = 1800; // 30 minutes
                this.isBlockedMsg = `Votre compte est temporairement bloqué. Veuillez attendre la page dans ${ this.$options.computed.formatTime(this.time) } et un nouveau code vous sera renvoyé pour vous connecter.`;
                this.interval = setInterval(() => {
                  this.time -= 1;
                }, 1000);
                this.errorOtp = false;
                this.errorOtpMsg = '';
                window.scrollTo(0,0);
              } else {
                this.errorOtp = true;
                this.errorOtpMsg = res.message;
              }
            }
          })
          .catch((err) => {
            logger.error('Err auth/validateOtpCollab', err);
            this.isLoading = false;
            this.errorOtp = true;
            this.errorOtpMsg = "Une erreur est survenue. Veuillez réessayer.";
          });
      } else {
        this.isLoading = false;
        this.errorOtp = true;
        this.errorOtpMsg = "Veuillez saisir le code à 6 chiffres.";
      }
    },
    authenticate(euid) {
      this.isLoading = false;
      this.$router.push(`/app/installation?euid=${euid}`);
    },
    countdownEnded() {
      this.isCountdown = false;
    }
  }
};
</script>

<style lang="scss">
</style>